import React from 'react';
import '../CSS/HigherEducation.css';

const higherEducationLogos = [
  { src: '/assets/Web Version/Who We Serve/Higher Education/fort-valley-univ-logo.png', alt: 'Fort Valley State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/middle-georgia-univ-logo.png', alt: 'Middle Georgia State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/pimacommunity-college-logo.png', alt: 'Pima Community College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/bethune-cookman-univ-logo.png', alt: 'Bethune-Cookman University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/bigsandy-college-logo.png', alt: 'Big Sandy Community & Technical College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/broward-college-logo.png', alt: 'Broward College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/fgcu-univ-logo.png', alt: 'Florida Gulf Coast University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/columbus-univ-logo.png', alt: 'Columbus State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/famu-univ-logo.png', alt: 'Florida Agricultural and Mechanical University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/florida-univ-logo.png', alt: 'Florida Atlantic University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/florida-polytechnic-univ-logo.png', alt: 'Florida Polytechnic University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/university-of-central-florida-logo.png', alt: 'University of Central Florida' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/northwest-florida-college-logo.png', alt: 'Northwest Florida State College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/university-of-alabama-logo.png', alt: 'The University of Alabama' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/dakota-univ-logo.png', alt: 'Dakota Wesleyan University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/kentucky-univ-logo.png', alt: 'Kentucky State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/gannon-univ-logo.png', alt: 'Gannon University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/atm-univ-logo.png', alt: 'Texas A&M University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/coker-univ-logo.png', alt: 'Coker University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/ivy-tech-univ-logo.png', alt: 'Ivy Tech Community College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/montanatech-univ-logo.png', alt: 'MontanaTech' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/university-of-montana-logo.png', alt: 'University of Montana' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/purdue-univ-logo.png', alt: 'Purdue University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/idaho-univ-logo.png', alt: 'Idaho State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/state-arkansas-univ-logo.png', alt: 'Arkansas State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/savannah-univ-logo.png', alt: 'Savannah State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/pennstate-univ-logo.png', alt: 'Penn State University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/gardner-webb-univ-logo.png', alt: 'Gardner-Webb University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/pfeiffer-univ-logo.png', alt: 'Pfeiffer University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/university-of-south-carolina-univ-logo.png', alt: 'University of South Carolina' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/rhode-univ-logo.png', alt: 'Rhode Island College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/und-univ-logo.png', alt: 'University of North Dakota' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/utah-valley-univ-logo.png', alt: 'Utah Valley University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/carroll-univ-logo.png', alt: 'Carroll University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/winthrop-univ-logo.png', alt: 'Winthrop University' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/gordon-univ-logo.png', alt: 'Gordon State College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/go-west-uwg-univ-logo.png', alt: 'Go West UWG' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/phsc-univ-logo.png', alt: 'PHSC Pasco-Hernando State College' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/kidspeace-univ-logo.png', alt: 'KidsPeace' },
  { src: '/assets/Web Version/Who We Serve/Higher Education/college-of-charleston-univ-logo.png', alt: 'College of Charleston' },
];

const HigherEducation: React.FC = () => {
  return (
    <div className="higher-education-page">
      <div className="higher-education-hero-banner">
        <div className="higher-education-hero-content">
          <p className="higher-education-breadcrumb">Who We Serve / Higher Education</p>
          <h1 className="higher-education-title">Higher Education</h1>
        </div>
      </div>

      <div className="higher-education-body">
        <div className="higher-education-intro">
          <p>
            Myers McRae has partnered with universities, colleges, and higher education
            systems nationwide to recruit leaders who shape the future of learning. Our team combines deep academic
            insight with the intelligent use of AI-driven research tools to enhance precision and reach in every search.
            From community colleges to nationally recognized universities, we understand the leadership qualities that
            inspire transformation. Each engagement reflects our commitment to integrity, excellence, and innovation.
            We are proud to highlight some of the distinguished institutions that have trusted Myers McRae with their
            leadership searches.
          </p>
        </div>

        <div className="higher-education-icons">
          {higherEducationLogos.map((logo) => (
            <div key={logo.alt} className="higher-education-icon-cell">
              <img src={logo.src} alt={logo.alt} className="higher-education-icon" />
            </div>
          ))}
        </div>

        {/* <div className="higher-education-icon-text">
          <p>and many more...</p>
        </div> */}
      </div>
    </div>
  );
};

export default HigherEducation;

